import React from 'react'
import { css } from 'styled-components/macro'

import { colors } from '../../constants/theme'

const EnvBanner = () => {
  let system
  let color

  switch (process.env.REACT_APP_PROJECT_ID) {
    case 'ddd-geo-dev':
      system = 'development'
      color = colors.error
      break
    case 'ddd-geo-staging':
      system = 'staging'
      color = colors.warning
      break
    default:
      return null
  }

  return (
    <div
      css={css`
        color: white;
        background-color: ${color};
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        font-size: .85rem;
      `}
    >
      {`Warning! This is a ${system} environment`}
    </div>
  )
}

export default EnvBanner
